import React from "react";
import { ServicesPage } from "../Components/Services/Services";

const Services = () => {
	return <ServicesPage />;
};

export default Services;
